import React from 'react';
import S from '@/styles/reactImgsBallast.module.css';

const InfoL = ({ top, left, L }) => {
  return (
    <>
      {L > 0 ? (
        <div className={S.value} style={{ top: top, left: left, width: 'auto' }}>
          {L > 0 ? `L = ${L}T` : 'L'}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default InfoL;
